import { render, staticRenderFns } from "./BasicSvg.vue?vue&type=template&id=72dd000f&scoped=true&"
import script from "./BasicSvg.vue?vue&type=script&lang=js&"
export * from "./BasicSvg.vue?vue&type=script&lang=js&"
import style0 from "./BasicSvg.vue?vue&type=style&index=0&id=72dd000f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dd000f",
  null
  
)

export default component.exports